import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {
  private apiUrl = `${environment.baseUrl}/organisation-module-mapping`; 

  constructor(private http: HttpClient) { }

  getModulesByOrganisationId(organisationId?: string|null): Observable<any> {
    return this.http.get(`${this.apiUrl}/organisation/${organisationId}`);
  }

  createOrganisationModuleMapping(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}`, data);
  }

  deleteOrganisationModuleMapping(organisationId: string, moduleId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/organisation/${organisationId}/module/${moduleId}`);
  }
}